export enum TrajectoryFunctionType {
  LINEAR = 'linear',
  EXPONENTIAL = 'exponential',
  MANUAL = 'manual',
}
